import React from "react";
import { Grid, Typography } from "@mui/material";
import { DAYS_IN_WEEK } from "./constants";

const CalendarWeekdayLabels = () => (
  <Grid
    container
    spacing={2}
    sx={{ position: "sticky", top: 0, zIndex: 1, backgroundColor: "#fff" }}>
    {DAYS_IN_WEEK.map((day) => (
      <Grid item xs={1.71} sm={1.71} key={day}>
        <Typography
          variant="caption"
          align="center"
          display="block"
          fontWeight="bold"
          color="text.secondary">
          {day}
        </Typography>
      </Grid>
    ))}
  </Grid>
);

export default CalendarWeekdayLabels;
